import { render, staticRenderFns } from "./Exco.vue?vue&type=template&id=6ad3ce62&"
import script from "./Exco.vue?vue&type=script&lang=ts&"
export * from "./Exco.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports